module.exports = __webpack_public_path__ + "media/images/pages/bg_largeStore-7d904be152531ae479718fe5840be0d8.jpg";